import { defineStore } from 'pinia';
import { ref } from 'vue';
import { RuleInfoProps } from '@/alert/components/alertDetail/alertDetail.types';
import { AlertRuleDetailV9 } from '@/api-client/alert/model';

const getDefaultSelectedRuleInfo = (): RuleInfoProps => ({
  alertRuleName: '',
  alertRuleType: 'user',
});

const getDefaultApiError = () => ({
  isError: false,
  message: '',
});

export const useAlertDetailStore = defineStore('alertDetail', () => {
  const selectedRuleInfo = ref<RuleInfoProps>(getDefaultSelectedRuleInfo());

  const userAlertInformationData = ref<AlertRuleDetailV9 | null>(null);
  const apiError = ref<{ isError: boolean; message: string }>(getDefaultApiError());

  const setUserAlertInformationData = (data: AlertRuleDetailV9 | null) => {
    userAlertInformationData.value = data;
  };
  const setApiError = (obj: { isError: boolean; message: string }) => {
    if (obj.isError) {
      apiError.value = obj;
    }
  };

  const reset = () => {
    selectedRuleInfo.value = getDefaultSelectedRuleInfo();
    userAlertInformationData.value = null;
    apiError.value = getDefaultApiError();
  };

  return {
    selectedRuleInfo,
    userAlertInformationData,
    setUserAlertInformationData,
    setApiError,
    apiError,
    reset,
  };
});
